import $ from 'jquery';
import Validator from '../helpers/Validator';

class Contact {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.$form = $('#contact-form');

        this.validator = new Validator(this.$form);

        this.$subjectSelect.on('change', () => this.onSubjectChange());
        this.$form.on('submit', () => this.validator.validateForm());
    }

    onSubjectChange() {
        const $extraInfo = $('.contact__extra-info');
        return subject === 'Partnerships' ? $extraInfo.show() : $extraInfo.hide();
    }

    static init() {
        if ($('#contact-form').length > 0) {
            new Contact();
        }
    }
}

export default Contact;
